import { Box, styled } from "@mui/material";

export const RecommendadionPumpContainer = styled<any>(Box)`
  padding: 16px;
  width: 500px;
  border: 1px solid #ffd200;
  align-items: center;
  justify-content: center;
`;
